/**
 * Copyright 2024, Optimizely
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
export class EventEmitter {
    constructor() {
        this.id = 0;
        this.listeners = {};
    }
    on(eventName, listener) {
        var _a;
        if (!this.listeners[eventName]) {
            this.listeners[eventName] = new Map();
        }
        const curId = this.id++;
        (_a = this.listeners[eventName]) === null || _a === void 0 ? void 0 : _a.set(curId, listener);
        return () => {
            var _a;
            (_a = this.listeners[eventName]) === null || _a === void 0 ? void 0 : _a.delete(curId);
        };
    }
    emit(eventName, data) {
        const listeners = this.listeners[eventName];
        if (listeners) {
            listeners.forEach(listener => {
                listener(data);
            });
        }
    }
    removeListeners(eventName) {
        var _a;
        (_a = this.listeners[eventName]) === null || _a === void 0 ? void 0 : _a.clear();
    }
    removeAllListeners() {
        this.listeners = {};
    }
}
export const __platforms = ['__universal__'];
//# sourceMappingURL=event_emitter.js.map